import { APICore } from './apiCore';

const api = new APICore();

function addRebate_Api(params: {
    accountid: string;
    entrydate: string;
    description: string;
    totalamount: string;
    reference: string;
    cashcounterid: string;
    cashreceived: string;
    bankid: string;
    bankreceived: string;
    transtype:string;
    voucherdetdata: [];
}) {
    const baseUrl = '/save-rebate-received';
    return api.create(`${baseUrl}`, params);
}
function addRebatePaid_Api(params: {
    accountid: string;
    entrydate: string;
    description: string;
    totalamount: string;
    reference: string;
    cashcounterid: string;
    cashpaid: string;
    bankid: string;
    bankpaid: string;
    transtype:string;
    voucherdetdata: [];
}) {
    const baseUrl = '/save-rebate-paid';
    return api.create(`${baseUrl}`, params);
}
function updRebatePaid_Api(params: {
    id: string;
    accountid: string;
    entrydate: string;
    description: string;
    totalamount: string;
    reference: string;
    cashcounterid: string;
    cashpaid: string;
    bankid: string;
    bankpaid: string;
    transtype:string;
    voucherdetdata: [];
}) {
    const baseUrl = `/update-rebate-paid/${params.id}`;
    return api.update(`${baseUrl}`, params);
}
function updRebate_Api(params: {
    id: string;
    accountid: string;
    entrydate: string;
    description: string;
    totalamount: string;
    reference: string;
    cashcounterid: string;
    cashreceived: string;
    bankid: string;
    bankreceived: string;
    transtype:string;
    voucherdetdata: [];
}) {
    const baseUrl = `/update-rebate-received/${params.id}`;
    return api.update(`${baseUrl}`, params);
}
export { addRebate_Api ,updRebate_Api,addRebatePaid_Api,updRebatePaid_Api};
